import {Link} from "react-router-dom";

export function ConnectSuccessLayout(props: { title: string, description: string, redirectTo: string, buttonLabel: string }) {
    return <div className="mx-auto max-w-2xl text-center">

        <div className="flex items-center flex-col my-8">
            <div role="status">
                <div className="flex-shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke-width="1.5"
                         stroke="currentColor" className="size-24 text-green-400">
                        <path stroke-linecap="round" stroke-linejoin="round"
                              d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"/>
                    </svg>
                </div>
            </div>
        </div>
        <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{props.title}</p>
        <p className="mt-6 text-lg leading-8 text-gray-600">{props.description}</p>

        <div className="flex justify-center w-full mt-16">
            <Link to={props.redirectTo}
               className="inline-flex items-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-sm hover:opacity-70 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary">
                {props.buttonLabel} &rarr;
            </Link>
        </div>
    </div>;
}
